/*--------------------------------------------------------------
# Custom scripts for logoCarouselSlider block
--------------------------------------------------------------*/

const logoCarouselSliders = document.querySelectorAll('.logo-carousel__slider');

for ( let i = 0; i < logoCarouselSliders.length; i++ ) {
    const sliderWrapper = logoCarouselSliders[i];
    const swiperEl      = sliderWrapper.querySelector('.swiper');
    const nextEl        = sliderWrapper.querySelector('.logo-carousel-swiper-next');
    const prevEl        = sliderWrapper.querySelector('.logo-carousel-swiper-prev');

    if ( ! swiperEl || ! nextEl || ! prevEl ) {
        continue;
    }

    new Swiper(swiperEl, {
        centerInsufficientSlides: true,
        grabCursor: true,
        slidesPerGroup: 1,
        slidesPerView: 2,
        spaceBetween: 24,
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        watchOverflow: true,
        breakpoints: {
            450: {
                slidesPerView: 3,
            },
            567: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 6,
            },
            1024: {
                slidesPerView: 7,
            },
        },
    });
}
